import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { FileIcon, FolderIcon, FolderOpenIcon } from 'foundations-assets';
import { NavListItem } from '../NavListItem/NavListItem';
import { jsx as _jsx } from "react/jsx-runtime";
export const FolderNavItem = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const getIconLeft = ({
    open
  } = {}) => {
    let IconLeft = /*#__PURE__*/_jsx(FileIcon, {
      color: "fill-accent-blue-default",
      size: "400"
    });
    if (children) {
      IconLeft = open ? /*#__PURE__*/_jsx(FolderOpenIcon, {
        color: "fill-accent-blue-default",
        size: "400"
      }) : /*#__PURE__*/_jsx(FolderIcon, {
        color: "fill-accent-blue-default",
        size: "400"
      });
    }
    return IconLeft;
  };
  return /*#__PURE__*/_jsx(NavListItem, Object.assign({
    iconLeft: getIconLeft
  }, rest, {
    children: children
  }));
};